module.exports = __webpack_public_path__ + "components/rewards/coolbus/static/logo-0246c3914fcc8c23884fe09bf63fe04b.webp";